import { observer } from 'mobx-react';
import * as React from 'react';
import CartItem from 'models/CartItem';
import SharedCartItem from 'models/SharedCartItem';
import MenuItem from 'models/MenuItem';
import Cart from 'models/Cart';
import { Plus } from 'assets/custom-icons';
import { CartIconWrapper, IconButton, IconWrapper } from './recommendationStyles';
import QuantityStepper from './QuantityStepper';
import { addItemToCart, handleDecreaseQty, handleIncreaseQty, removeItemFromCart } from './utils';

interface BaseStepperType {
  itemId: string;
  selectedCart: Cart;
  fromCart: boolean;
  adjustPadding: boolean;
  setVisible: (visible: boolean) => void;
  referringItem?: MenuItem;
  existingCartItem?: CartItem | SharedCartItem;
  quantity?: number;
}

type StepperWithItemInCart = BaseStepperType & {
  itemInCart: true;
  pushCartItem?: (newCartItem: CartItem | SharedCartItem) => void;
  newCartItem?: CartItem | SharedCartItem;
};

type StepperWithoutItemInCart = BaseStepperType & {
  itemInCart: false;
  pushCartItem: (newCartItem: CartItem | SharedCartItem) => void;
  newCartItem: CartItem | SharedCartItem;
};

type StepperType = StepperWithItemInCart | StepperWithoutItemInCart;

function Stepper({
  existingCartItem,
  pushCartItem,
  itemId,
  newCartItem,
  itemInCart,
  selectedCart,
  referringItem,
  fromCart,
  setVisible,
  quantity,
  adjustPadding,
}: StepperType) {
  const cartItem = existingCartItem ?? selectedCart?.items.find((item) => item.menu_item_id === itemId);
  React.useEffect(() => {}, [cartItem?.qty]);
  const itemList = document.getElementById('cart-items-list');
  const Wrapper = adjustPadding ? CartIconWrapper : IconWrapper;

  return itemInCart ? (
    <QuantityStepper
      quantity={quantity ?? cartItem?.qty ?? 0}
      onIncrement={() =>
        handleIncreaseQty({ setAppliedLoyaltyRewards: selectedCart.setAppliedLoyaltyRewards, cartItem })
      }
      onDecrement={() =>
        handleDecreaseQty({ setAppliedLoyaltyRewards: selectedCart.setAppliedLoyaltyRewards, cartItem })
      }
      onRemove={() => removeItemFromCart(selectedCart, cartItem)}
      adjustPadding={adjustPadding}
    />
  ) : (
    <Wrapper
      onClick={() => {
        if (newCartItem.hasMods()) {
          pushCartItem(newCartItem);
        } else {
          addItemToCart(itemId, selectedCart, newCartItem, referringItem);
        }
        if (fromCart) {
          setTimeout(() => {
            itemList?.scrollIntoView(false);
            setVisible(false);
          }, 400);
        }
      }}
    >
      <IconButton>
        <Plus />
      </IconButton>
    </Wrapper>
  );
}

export default observer(Stepper);
